'use client';
import classNames from 'classnames';
import { isH5HandleClient } from 'eco-design-micro/utils-base/isH5Handle';
import getLocal from 'eco-design-reliance/getLocal';
import EcoLink from 'eco-design/base/eco-link';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import LocaleIcon from './LocaleIcon';

const GLobalLocaleWin = dynamic(() => import('./GLobalLocaleWin'), {
    ssr: false,
});
export default function GlobalLocaleV1({ className, label = '', title }: { className?: string; label?: string; title: string }) {
    const { locale } = getLocal();
    const [isOpenA, setIsOpenA] = useState(false);
    const classes = classNames({
        [`${className}`]: className,
        [`glo-nav-locale-button`]: true,
    });
    // 打开
    const openHandleA = (e: any) => {
        const isH5 = isH5HandleClient();
        if (isH5) return;
        e.preventDefault();
        setIsOpenA(true);
    };
    // 关闭
    const hideHandleA = () => {
        setIsOpenA(false);
    };

    return (
        <>
            <EcoLink
                className={`glo-nav-locale-href GtmModuleData-btn-href`}
                aria-label="locale link"
                href={`/${locale}/region`}
                onClick={openHandleA}
                dataLayer={{
                    __btn_id1: 'glo-nav-locale-href',
                    __btn_id2: `${locale}/region`,
                    __btn_type: 'href',
                }}
            >
                <LocaleIcon />
                <span>{title}</span>
            </EcoLink>

            {isOpenA && <GLobalLocaleWin callback={hideHandleA} />}
        </>
    );
}
